export default __webpack_public_path__ + "static/media/ShaulunMap.abb872c4.jpg";